import React from "react";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import classes from "./PriceInput.module.css";
import PropTypes from "prop-types";

export const PriceInput = ({
  state,
  setter,
  label,
  customStyle,
  prefix,
  type,
  postfix,
  maxValueLength,
}) => {
  return (
    <>
      <style jsx>{`
        .${classes.priceInputBox} {
          border: 1px solid ${Colors.neutralShadesOfGainsboro};
          background-color: ${Colors.white};
        }
        .${classes.priceInputBox}:focus-within {
          border: 1px solid ${Colors.neutralShadesOfNero};
        }
        .${classes.distanceInputMiles} {
          position: relative;
          color: black;
        }
        .${classes.distanceInputMiles} {
          position: absolute;
          content: "miles";
          top: 50%;
          transform: translateY(-50%);
          left: ${(state.toString()?.length + 1) * 7}px;
        }
      `}</style>
      <div
        className={`${[classes.priceInputBox].join(" ")}`}
        style={{ ...customStyle }}
      >
        <label style={{ ...Fonts.p4, color: Colors.neutralShadesOfDimGray }}>
          {label}
        </label>
        <div
          className={` ${[
            classes.dollarSignWithInput,
            // postfix && classes.distanceInputMiles,
          ].join(" ")}`}
        >
          {prefix && (
            <span
              style={{
                ...Fonts.input2,
                color: Colors.neutralShadesOfNero,
              }}
            >
              {prefix}
            </span>
          )}
          <input
            value={state}
            onChange={(e) => {
              const { value } = e.target;
              if(maxValueLength){
                if (value.length < maxValueLength) {
                  setter(e.target.value);
                }
              } else {
                setter(e.target.value);
              }
            }}
            className={` ${[classes.input].join(" ")}`}
            style={{
              ...Fonts.input2,
              color: Colors.neutralShadesOfNero,
              lineHeight: "16px",
            }}
            type={type}
          />
          {postfix && (
            <span
              style={{
                ...Fonts.input2,
                color: Colors.neutralShadesOfNero,
              }}
              className={` ${[classes.distanceInputMiles].join(" ")}`}
            >
              {postfix}
            </span>
          )}
        </div>
      </div>
    </>
  );
};

PriceInput.propTypes = {
  label: PropTypes.string,
  state: PropTypes.string,
  setter: PropTypes.func,
  customStyle: PropTypes.object,
  type: PropTypes.string,
  prefix: PropTypes.string,
  postfix: PropTypes.string,
  maxValueLength: PropTypes.number,
};
PriceInput.defaultProps = {
  label: "min price",
  type: "number",
};
